// extracted by mini-css-extract-plugin
export default {"box":"FcdqoMrKTgE7jXY4n5eQ"};